import { useCallback, useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { useDocumentVisibility } from 'ahooks';
import dayjsLocale from 'dayjs/locale/zh-cn';

dayjs.locale(dayjsLocale);
const useShowTime = (dateFormat = 'HH:mm') => {
  const [timeText, setTimeText] = useState('');
  const timer = useRef<NodeJS.Timeout>(null);
  const visibility = useDocumentVisibility();

  useEffect(() => {
    if (visibility === 'visible') {
      updateTime();
    }

    return () => {
      clearTimeout(timer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibility]);

  const updateTime = useCallback(() => {
    setTimeText(dayjs().format(dateFormat));

    // 计算下一分钟的开始时间
    const nextMinuteStart = dayjs().add(1, 'minute').startOf('minute');
    // 计算到下一分钟的时间差
    const diff = nextMinuteStart.diff(dayjs());
    // 在时间差之后再次更新时间
    timer.current = setTimeout(updateTime, diff);
  }, []);

  return timeText;
};

export default useShowTime;
